module.exports = __webpack_public_path__ + "static/children-photo-eecf45d083269d53c92ada321e3d2ef4.jpg";